import { Injectable } from '@angular/core';
import {PatientProxy} from "./patient.proxy";
import {HttpObservable} from "../../common/http-helpers/http.wrapper";
import {map} from "rxjs/operators";
import {ILoggedInPatient} from "../common/common.types";

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  constructor(private patientProxy: PatientProxy) {
  }

  public getPatientDetails(): HttpObservable<ILoggedInPatient> {
    return this.patientProxy.getPatientDetails();
  }
}
